import { render, staticRenderFns } from "./Pedidos.vue?vue&type=template&id=eb7a1d62&scoped=true"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"
import style0 from "./Pedidos.vue?vue&type=style&index=0&id=eb7a1d62&prod&lang=css"
import style1 from "./Pedidos.vue?vue&type=style&index=1&id=eb7a1d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7a1d62",
  null
  
)

export default component.exports